import { PerformanceTrace } from './types';

export const startDatadogTrace = (
  _operation: string,
  _metadata: Record<string, string>,
  _startedAt: number
): PerformanceTrace => ({
  stop: async () => undefined,
});
